import { computed } from "vue";
import type { MenuItem } from "@/types/navigation";
import { useU3tNavigationStore } from "@/stores/u3tNavigation";

export function useNavigation() {
    const navigationStore = useU3tNavigationStore();

    const convertToMenuItem = (item: any): MenuItem => {
        let iconName: string | undefined;
        if (item.icon && typeof item.icon === "object" && item.icon.attributes?.icon) {
            iconName = item.icon.attributes.icon[1];
        }
        return {
            id: item.id.toString(),
            title: item.title,
            icon: iconName ? `fa fa-${iconName}` : undefined,
            url: item.href,
            children: item.child?.map(convertToMenuItem),
        };
    };

    // Computed property to convert navigation items
    const navigationItems = computed<MenuItem[]>(() => {
        if (!navigationStore.isLoaded) return [];
        const nav = navigationStore.navigation();
        return nav.map(convertToMenuItem);
    });

    // Load navigation from SharePoint
    const loadNavigation = async () => {
        await navigationStore.getNavigation();
    };

    return {
        navigationItems,
        loadNavigation,
        isLoaded: computed(() => navigationStore.isLoaded),
    };
}
